export default {
  title: "عنوان المستخدم",
  subtitle: "تعديل معلومات عنوان المستخدم",

  addNew: "إضافة عنوان جديد",
  createAddress: "إنشاء عنوان",
  editAddress: "تحديث عنوان المستخدم",
  deleteAddress: "حذف العنوان",

  fields: {
    country: "البلد",
    city: "المدينة",
    address: "سطر العنوان الأول",
    address2: "سطر العنوان الثاني"
  },
  
  placeholders: {
    country: "اختر البلد",
    city: "اختر المدينة",
    address: "أدخل سطر العنوان الأول",
    address2: "أدخل سطر العنوان الثاني (اختياري)"
  },

  messages: {
    updateSuccess: "تم تحديث عنوان المستخدم بنجاح!",
    updateError: "خطأ في تحديث عنوان المستخدم",
    loadingError: "خطأ في تحميل عنوان المستخدم",
    loading: "جاري تحميل تفاصيل عنوان المستخدم..."
  },

  actions: {
    update: "تحديث العنوان",
    updating: "جاري التحديث...",
    back: "رجوع"
  },

  validation: {
    countryRequired: "البلد مطلوب",
    cityRequired: "المدينة مطلوبة",
    addressRequired: "سطر العنوان الأول مطلوب"
  },
  
  table: {
    user: "المستخدم",
    label: "التسمية",
    type: "النوع",
    address: "العنوان",
    city: "المدينة",
    country: "البلد",
    phone: "الهاتف",
    isDefault: "افتراضي",
    actions: "خيارات الأوامر"
  },
  
  types: {
    home: "المنزل",
    work: "العمل",
    billing: "الفوترة",
    shipping: "الشحن",
    other: "أخرى"
  },
  
  statusOptions: {
    active: "نشط",
    inactive: "غير نشط"
  },
  
  breadcrumbs: {
    userAddress: "عنوان المستخدم",
    edit: "تعديل"
  }
};
